import { useCallback, useRef } from "react";
import ModalBasicLayout from "./ModalBasicLayout";
import FeatureAddonUnpaidPaywall from "../FeatureAddons/FeatureAddonUnpaidPaywall";
import { FEATURE_ADDON_KEYS } from "../../actions/featureAddons";
import TemplateEditor from "../../pages/Templates/TemplateEditor";
import {
  TEMPLATES_MODAL_TYPE,
  useTemplatesModals,
} from "../../contexts/templatesModalsContext";
import { useTranslationApp } from "../../lib/i18next";
import { TEMPLATES_TITLE } from "../../i18n/keysTranslations";

const ModalTemplateEditor = ({
  modalOpen,
  onCloseModal,
  templateID = "",
  isProvisionalCreate = false,
  returnToProduce = false,
  initialPreviewProduceID = "",
  previewRequestKey = "",
}) => {
  const { t } = useTranslationApp();
  const { openTemplatesList, stack } = useTemplatesModals();
  const editorCloseRef = useRef(null);
  const produceAlreadyOpen = stack.some(
    (entry) => entry.type === TEMPLATES_MODAL_TYPE.PRODUCE
  );
  const closeToProduce = returnToProduce || produceAlreadyOpen;

  const onBackToList = useCallback(() => {
    onCloseModal();
    if (!closeToProduce) {
      openTemplatesList();
    }
  }, [closeToProduce, onCloseModal, openTemplatesList]);

  const onCloseFromModal = useCallback(async () => {
    if (editorCloseRef.current) {
      await editorCloseRef.current();
      return;
    }
    onBackToList();
  }, [onBackToList]);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseFromModal}
      fullScreen={true}
      maxWidth={false}
      fullWidth={true}
      hasTitle={false}
      ariaLabel={t(TEMPLATES_TITLE)}
      sxContent={{
        p: 0,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
      sxPaper={{
        height: "100vh",
        maxHeight: "100vh",
      }}
    >
      <FeatureAddonUnpaidPaywall addonKey={FEATURE_ADDON_KEYS.TEMPLATES} />
      <TemplateEditor
        templateID={templateID}
        isProvisionalCreate={isProvisionalCreate}
        returnToProduce={closeToProduce}
        initialPreviewProduceID={initialPreviewProduceID}
        previewRequestKey={previewRequestKey}
        onBackToList={onBackToList}
        onRegisterCloseHandler={(handler) => {
          editorCloseRef.current = handler;
        }}
      />
    </ModalBasicLayout>
  );
};

export default ModalTemplateEditor;
